export class Log
{
    public date: string;
    public email: string;
    public template: string;
    public action: string;

    constructor ()
    {}
}